import { footprintPrice } from "../../../components/store";
import { ShopifyShopSystemStrategy } from "./ShopifyShopSystemStrategy";

type ManagementClass = Element & {
  getSectionsToRender(): { id: string; section: string; selector: string }[];
  //TODO: Type this
  updateQuantity(line: any, quantity: any, name: any): void;
  enableLoading(line?: any): void;
  disableLoading(): void;
  updateLiveRegions(line: any, itemCount: any): void;
  getSectionInnerHTML(html: any, selector: any): string;
};

export class MybacsShopSystemStrategy extends ShopifyShopSystemStrategy {
  isReOffsetting: boolean = false;

  registerEventHandlers(): void {
    const node = document.querySelector(".cart__items");
    const observer = new MutationObserver((mutations, observer) => {
      if (this.isReOffsetting) return;
      window.dispatchEvent(new CustomEvent("CartReRendered", {}));
    });
    if (node) {
      observer.observe(node, {
        attributes: false,
        childList: true,
        subtree: false,
      });
    }

    window.addEventListener("cart-change", async () => {
      const cart = await this.getCart();
      const offset = this.getOffsetItem(cart);
      if (offset && cart!.items.length === 1) {
        await this.toggleOffset(false, true);
      }
    });

    // Check if we need to re-offset the cart when the footprint price changes.
    // This also catches the case of adding a product on a page that
    // doesn't load the plugin, and then navigates to a page that has
    // the plugin, as this will trigger once the offset is known.
    footprintPrice.subscribe(async (value) => {
      if (value == 0) return;
      const cart = await this.getCart();
      const offset = this.getOffsetItem(cart);
      if (!offset) return;
      // If our price already matches, nothing needs to happen.
      if (offset.price != Math.round(value * 100)) {
        this.isReOffsetting = true;
        // Refresh if this if the offset is the last item in the cart.
        await this.toggleOffset(false, cart!.items.length === 1);
        this.isReOffsetting = false;
        if (cart!.items.length > 1) await this.toggleOffset(true);
      }
    });
  }

  manager(): ManagementClass {
    return document.querySelector("cart-items") as unknown as ManagementClass;
  }

  beginOffset(): void {
    this.manager().enableLoading();
  }

  endOffset(): void {
    this.manager().disableLoading();
  }

  bundledSections(): string[] {
    return this.filteredSections().map((section) => section.section);
  }

  filteredSections() {
    // Only update the main cart summary, as we hide our product in the cart.
    const sections = this.manager()
      .getSectionsToRender()
      .filter((section) => section.id === "main-cart-summary");

    return sections;
  }

  bundledSectionsCallback(sections: any): void {
    const manager = this.manager();

    manager.classList.toggle("is-empty", sections.item_count === 0);

    this.filteredSections().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id)?.querySelector(section.selector) ||
        document.getElementById(section.id)!;
      elementToReplace.innerHTML = manager.getSectionInnerHTML(
        sections[section.section],
        section.selector,
      );
      document.body.dispatchEvent(new CustomEvent("cart-update"));
    });
    window.dispatchEvent(new CustomEvent("CartReRendered", {}));
  }
}
